const CalculateFaceRecognitionRequest = function () {
  return {
    "nfcPhoto": "",
    "leadPhoto": "",
    "identityNumber": "",
    "processId": ""
  }
};

export default CalculateFaceRecognitionRequest;



// WEBPACK FOOTER //
// ./src/service/request/CalculateFaceRecognitionRequest.js